document.addEventListener("DOMContentLoaded", () => {
  const tabLinks = document.querySelectorAll(".tab-link");
  const tabContents = document.querySelectorAll(".tab-content");

  tabLinks.forEach((link) => {
    link.addEventListener("click", () => {
      const targetTab = link.dataset.tab;

      tabLinks.forEach((link) => link.classList.remove("active"));
      tabContents.forEach((content) => content.classList.remove("active"));

      link.classList.add("active");
      document.getElementById(targetTab).classList.add("active");
    });
  });

  
  const accordionHeaders = document.querySelectorAll(".accordion-header");

  accordionHeaders.forEach((header) => {
    header.addEventListener("click", () => {
      const isActive = header.classList.contains("active");
      const targetContent = document.getElementById(header.dataset.tab);

      accordionHeaders.forEach((h) => h.classList.remove("active"));
      document
        .querySelectorAll(".accordion-content")
        .forEach((content) => content.classList.remove("active"));

      if (!isActive) {
        header.classList.add("active");
        targetContent.classList.add("active");
      }
    });
  });
});

// tabify section js end

/*grid js in collection page */
document.addEventListener("DOMContentLoaded", function() {
    function toggleGridView() {
        let grid1 = document.querySelector("#grid1");
        let grid2 = document.querySelector("#grid2");
        let collection_grid = document.querySelector(".collection");

        if (grid2) {
            grid2.addEventListener("click", function() {
                grid2.classList.add('active');
                if (grid1) grid1.classList.add('grid_button');
                if (collection_grid) collection_grid.classList.add('show');
            });
        }

        if (grid1) {
            grid1.addEventListener("click", function() {
                if (grid2) grid2.classList.remove('active');
                grid1.classList.remove('grid_button');
                if (collection_grid) collection_grid.classList.remove('show');
            });
        }
    }

    toggleGridView();
});
document.addEventListener("DOMContentLoaded", function() {
    function updateProductImage() {
        document.querySelectorAll('.product_all_media img').forEach(img => {
            img.addEventListener('click', function(event) {
                event.preventDefault();  
                const srcsetValue = img.getAttribute('srcset');
                const mediaImg = img.closest('.card')?.querySelector('.card__media .media img');
                if (mediaImg) {
                    mediaImg.setAttribute('srcset', srcsetValue);
                }
            });
        });
    }
    updateProductImage();
});

/* hotspot section */

document.addEventListener("DOMContentLoaded", function () {
  var imageEclipse1 = document.querySelector(".image-eclipse-1");
  var imageEclipse2 = document.querySelector(".image-eclipse-2");
  var imageEclipse3 = document.querySelector(".image-eclipse-3");
  var eclipse1 = document.querySelector(".eclipse1");
  var eclipse2 = document.querySelector(".eclipse2");
  var eclipse3 = document.querySelector(".eclipse3");
  if (eclipse1) {
    eclipse1.classList.add("active");
  }
  if (imageEclipse1 && imageEclipse2 && imageEclipse3 && eclipse1 && eclipse2 && eclipse3) {
    imageEclipse1.addEventListener("click", function () {
      eclipse2.classList.remove("active");
      eclipse3.classList.remove("active");
      eclipse1.classList.add("active");
    });

    imageEclipse2.addEventListener("click", function () {
      eclipse3.classList.remove("active");
      eclipse1.classList.remove("active");
      eclipse2.classList.add("active");
    });

    imageEclipse3.addEventListener("click", function () {
      eclipse2.classList.remove("active");
      eclipse1.classList.remove("active");
      eclipse3.classList.add("active");
    });
  } 
});

/* scroll js */
const Srollbutton = document.querySelector('.social_widget');
 const displayButton = () => {
    window.addEventListener('scroll', () => {
          if (window.scrollY > 200) {
            Srollbutton.style.display = "block";
          } else {
            Srollbutton.style.display = "none";
          }
        });
  };
 displayButton();

/* gallery js */
  $('.gallery_show').slick({
          dots: false,
          arrow:true,
          infinite: true,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 1,
          prevArrow:'<div class="arrow prev"><svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 1024 1024" class="icon" version="1.1" fill="#ffffff" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"/><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"><path d="M768 903.232l-50.432 56.768L256 512l461.568-448 50.432 56.768L364.928 512z" fill="#ffffff"/></g></svg></div>',
          nextArrow:'<div class="arrow next"><svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 1024 1024" class="icon" version="1.1" fill="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"/><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"><path d="M256 120.768L306.432 64 768 512l-461.568 448L256 903.232 659.072 512z" fill="#ffffff"/></g></svg></div>',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: false
              }
            },
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });


  $(document).ready(function(){
   $('.test_slider').slick({
          dots: true,
          arrows:false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
         autoplay:true,
         autoplaySpeed:3000,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                 dots: true
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                 dots: true
              }
            }
          ]
        });

  });

/* shipping js */
window.addEventListener('DOMContentLoaded', (event) => {
    // Init Shipping Calc feature
    const initShippingCalc = async (preload = false) => {
        const element = document.querySelector('#eg-shipping-calc')
        const cartDrawerItems = document.querySelector('cart-drawer-items')
        const cartFooter = document.querySelector('.cart__footer')

        const countryProvinceSelector = new Shopify.CountryProvinceSelector('eg-shipping-calc-country', 'eg-shipping-calc-province', {
            hideElement: 'eg-shipping-calc-province-wrapper'
        });

        // Check if the element has already been cloned once
        if (cartDrawerItems && !cartDrawerItems.classList.contains('is-empty')) {
          cartDrawerItems.insertAdjacentElement('beforeend', element.cloneNode(true));
          document.querySelector('#CartDrawer #eg-shipping-calc').style.display = 'block';
        }

        if (cartFooter) {
            cartFooter.insertAdjacentElement('afterbegin',element.cloneNode(true))
            document.querySelector('#MainContent #eg-shipping-calc').style.display = 'block'
        }
    }
    initShippingCalc();

    const selectAllshippingCountry = document.querySelectorAll("#eg-shipping-calc-country");
let selectedValue;

selectAllshippingCountry.forEach(selectElement => {
    selectElement.addEventListener("change", (event) => {
        // Get the selected option
        selectedValue = event.target.selectedOptions[0];
        console.log("selectedValue: ", selectedValue);

        // Set the selected option for all #eg-shipping-calc-country elements
        selectAllshippingCountry.forEach(element => {
            // Find the option with the selected value and set it as selected
            const optionToSelect = Array.from(element.options).find(option => option.value === selectedValue.value);
            if (optionToSelect) {
                optionToSelect.selected = true;

                // Check if selectedValue has data-provinces
                const dataProvinces = selectedValue.getAttribute('data-provinces');
                if (dataProvinces) {
                    const allProvinceWrappers = document.querySelectorAll("#eg-shipping-calc-province-wrapper");
                    const dataProvincesArr = dataProvinces.split(" ");
                    if(dataProvincesArr.length > 1) {
                       // Toggle the style display for allProvinceWrappers
                      allProvinceWrappers.forEach(wrapper => {
                          wrapper.style.display = 'block';
                      });
                    } else {
                          // Toggle the style display for allProvinceWrappers
                          allProvinceWrappers.forEach(wrapper => {
                              wrapper.style.display = 'none';
                          });
                      }
                }
            }
        });

        const countryProvinceSelector = new Shopify.CountryProvinceSelector('eg-shipping-calc-country', 'eg-shipping-calc-province', {
            hideElement: 'eg-shipping-calc-province-wrapper'
        });
    });
});
    // Generate Shipping rates
    // https://shopify.dev/docs/api/ajax/reference/cart#generate-shipping-rates
    window.generateShippingRates = async (btn) => {
        btn.textContent = btn.dataset.labelLoading

        const wrapper = btn.parentNode

        wrapper.querySelector('#eg-shipping-calc-alert-danger').innerHTML = ''
        wrapper.querySelector('#eg-shipping-calc-alert-danger').setAttribute('hidden', 'hidden')
        wrapper.querySelector('#eg-shipping-calc-alert-warning').innerHTML = ''
        wrapper.querySelector('#eg-shipping-calc-alert-warning').setAttribute('hidden', 'hidden')
        wrapper.querySelector('#eg-shipping-calc-alert-success').innerHTML = ''
        wrapper.querySelector('#eg-shipping-calc-alert-success').setAttribute('hidden', 'hidden')

        const country = wrapper.querySelector('#eg-shipping-calc-country').value
        const province = wrapper.querySelector('#eg-shipping-calc-province').value
        const zip = wrapper.querySelector('#eg-shipping-calc-zip').value

        const prepareResponse = await fetch(`/cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`, {
            method: 'POST'
        })
        console.log(prepareResponse)

        if (prepareResponse.ok) {
            const asyncRespose = await fetch(`/cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`)
            console.log(asyncRespose)

            const data = await asyncRespose.json()
            console.log(data)

            let html = ''

            if (data.shipping_rates.length) {
                data.shipping_rates.forEach(elem => {
                    html += `
                        <li>
                            ${elem.presentment_name}: <strong>${elem.price} ${elem.currency}</strong>
                        </li>
                    `
                })

                wrapper.querySelector('#eg-shipping-calc-alert-success').innerHTML = `
                    <ul class="">
                        ${html}
                    </ul>
                `
                wrapper.querySelector('#eg-shipping-calc-alert-success').removeAttribute('hidden')
            } else {
                wrapper.querySelector('#eg-shipping-calc-alert-warning').innerHTML = `
                    <p class="">
                        ${modal.dataset.textNoResults}
                    </p>
                `
                wrapper.querySelector('#eg-shipping-calc-alert-warning').removeAttribute('hidden')
            }
        } else {
            const data = await prepareResponse.json()
            console.log(data)

            let html = ''

            for (const [key, value] of Object.entries(data)) {
                html += `
                    <li>
                        <strong>${key}</strong>: ${value.toString()}
                    </li>
                `
            }

            wrapper.querySelector('#eg-shipping-calc-alert-danger').innerHTML = `
                <ul class="">
                    ${html}
                </ul>
            `
            wrapper.querySelector('#eg-shipping-calc-alert-danger').removeAttribute('hidden')
        }

        btn.textContent = btn.dataset.label
    }

})
/* variant option */

function printVariantName(optionValue) {
      document.getElementById("selected-variant").innerText = optionValue;
      // Remove active class from all swatches
      document.querySelectorAll('.itg_swatch').forEach(el => el.classList.remove('active'));
      // Add active class to clicked swatch
      event.currentTarget.classList.add('active');
  }